module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer_Grieg.469993f8.jpg";